export const notepad = {
    rolesCanShowBannerInfo: ['administrator']
};
